import type { ReactElement } from "react";

import image from "@/assets/holiday-cards/holiday-card-ice-breakers.png";
import { DayDefinition } from "../DayDefinition.js";
import RandomButton from "../shared/RandomButton.js";

/**
 * Class Ice_Breakers
 *
 * Represents the Ice-Breakers card.
 */
export class Ice_Breakers extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-darkbrown2022";
	public image = image;
	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "ice-breakers";

	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "Ice Breakers &amp; Conversation Starters";
		this.content = <ENContent />;
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title = "Comment engager une conversation ?";
		this.content = <FRContent />;
	}
}

/**
 * The English content for the Ice Breakers card.
 *
 * @returns The English content for the Ice Breakers card.
 */
function ENContent(): ReactElement {
	const icebreakers = [
		"If you could be any animal, which one would you be?",
		"Would you rather be invisible or be able to fly?",
		"What’s one song that you think will never get old?",
		"What’s the best piece of advice you’ve ever been given?",
		"What does your ideal weekend look like?",
		"What are the top 3 places to visit on your bucket list?",
		"Name one person you wish you could have lunch with?",
		"Coffee or tea?",
		"Ketchup or mustard?",
		"What is your favourite dessert?",
		"If you were a season, what season would you be?",
		"If you could instantly become an expert in something, what would it be?",
		"Would you rather be able to read minds or understand every single language?",
	];
	return (
		<>
			<p className="hl:whitespace-pre-line">
				{`Talking about the weather can only get you so far
				So here are some topics to set the conversation bar
				You may learn something new about a family friend
				You may not even want the conversation to end`}
			</p>
			<RandomButton
				buttonTheme="foliage"
				content={icebreakers}
				title="Get an icebreaker"
			/>
		</>
	);
}

/**
 * The French content for the Ice Breakers card.
 *
 * @returns The French content for the Ice Breakers card.
 */
function FRContent(): ReactElement {
	const icebreakers = [
		"Si vous deviez être un animal, lequel serait-ce ?",
		"Préférez-vous être invisible ou être capable de voler ?",
		"Selon vous, quelle la chanson ne se démodera jamais ?",
		"Quel est le meilleur conseil qu'on vous ait jamais donné ?",
		"À quoi ressemble votre week-end idéal ?",
		"Quels sont les trois destinations prioritaires sur votre liste de choses à faire avant de mourir ?",
		"Nommez une personne avec laquelle vous aimeriez déjeuner ?",
		"Thé ou café ?",
		"Ketchup ou moutarde ?",
		"Quel est votre dessert préféré ?",
		"Si vous étiez une saison, laquelle serait-ce ?",
		"Si vous pouviez devenir expert en quelque chose, quel domaine choisiriez-vous ?",
		"À choisir, préférez-vous lire dans les pensées ou comprendre toutes les langues ?",
	];
	return (
		<>
			<p className="hl:whitespace-pre-line">
				{`Parler de la météo ne vous mènera pas très loin
				Voici donc quelques sujets de conversation pour aller bon train
				Et d’intéressantes nouvelles à venir sur un ami de la famille
				Si bien qu’il vous sera difficile quitter une si bonne compagnie.`}
			</p>
			<RandomButton
				buttonTheme="foliage"
				content={icebreakers}
				title="Apprenez à briser la glace"
			/>
		</>
	);
}
